import type { EnnismoreTheme } from '@/ui/theme';

import { orientExpressTheme } from './orientexpress.theme';

export const orientExpressVeniceTheme: EnnismoreTheme = {
  ...orientExpressTheme,
  logoUrl: '/brands/orientexpress/images/logo-venice.svg',
  componentProperties: {
    ...orientExpressTheme.componentProperties,
    footer: {
      ...orientExpressTheme.componentProperties.footer,
      emblemUrl: '/brands/orientexpress/images/footer-seal-venice.svg',
    },
    header: {
      ...orientExpressTheme.componentProperties?.header,
      logo: {
        ...orientExpressTheme.componentProperties?.header?.logo,
        padding: '0px',
      },
    },
    confirmation: {
      ...orientExpressTheme.componentProperties?.confirmation,
      header: {
        ...orientExpressTheme.componentProperties?.confirmation?.header,
        backgroundColor: '#BED1D4',
      },
      title: {
        ...orientExpressTheme.componentProperties?.confirmation?.title,
        color: 'black',
      },
      confirmationMessage: {
        ...orientExpressTheme.componentProperties?.confirmation
          ?.confirmationMessage,
        color: 'black',
      },
    },
  },
};
